<template>
    <div class="box">
        <el-form label-width="auto">

            <SectionTitle title="基础信息" />
            <el-form-item label="标题">
                <el-input v-model="myObj.bottom_list_phototags_params.title" placeholder="请输入"></el-input>
            </el-form-item>

            <SectionTitle title="数据选择" />
            <el-form-item label="大栏目">
                <el-autocomplete clearable v-model="queryCategory" :fetch-suggestions="querySearchCategory"
                    placeholder="搜索/选择大栏目" @select="(item) => handleSelectCategory(item)"></el-autocomplete>
            </el-form-item>
            <el-form-item label="标签组">
                <el-autocomplete clearable v-model="queryTagGroup" :fetch-suggestions="querySearchTagGroup"
                    placeholder="搜索/选择标签组" @select="(item) => handleSelectTagGroup(item)"></el-autocomplete>
            </el-form-item>
            <el-form-item label="每页个数">
                <el-input-number v-model="myObj.source_list.params.per_page" :min="1"></el-input-number>
            </el-form-item>

            <SectionTitle title="样式设置" />

            <el-form-item label="展示类型">
                <el-select v-model="myObj.bottom_list_phototags_params.show_type" placeholder="请选择">
                    <el-option label="平铺样式" value="flat" />
                    <el-option label="分类样式" value="classify" />
                </el-select>
            </el-form-item>

            <el-form-item label="标题位置">
                <el-select v-model="myObj.bottom_list_phototags_params.text_position" placeholder="请选择">
                    <el-option v-for="item, index in positionOptions" :label="item.name" :value="item.value"
                        :key="index"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="左右间距">
                <el-input-number v-model="myObj.bottom_list_phototags_params.margin" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素间距">
                <el-input-number v-model="myObj.bottom_list_phototags_params.between_space" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="每列个数">
                <el-radio-group v-model="myObj.bottom_list_phototags_params.column">
                    <el-radio :label="2">2个</el-radio>
                    <el-radio :label="3">3个</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="元素圆角">
                <el-input-number v-model="myObj.bottom_list_phototags_params.corner_radius" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="高度比例">
                <el-input-number v-model="myObj.bottom_list_phototags_params.item_height_ratio"
                    :min="0"></el-input-number>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
import { GetAtlasCategoryList, GetAtlasTagGroup } from '@/request/api'

import SectionTitle from '@/components/SectionTitle.vue';
export default {
    name: "BottomListPhotoTagsProp",
    components: {
        SectionTitle
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,
            showTypeOptions: [
                { name: '图片列表样式', value: 'photolist' },
                { name: '瀑布流样式', value: 'waterfall' }],
            positionOptions: [
                { name: '左上', value: 1 },
                { name: '中上', value: 2 },
                { name: '右上', value: 3 },
                { name: '左中', value: 4 },
                { name: '正中', value: 5 },
                { name: '右中', value: 6 },
                { name: '左下', value: 7 },
                { name: '中下', value: 8 },
                { name: '右下', value: 9 }
            ],
            queryCategory: '',
            queryTagGroup: ''
        }
    },
    mounted() {
        this.queryCategory = this.myObj.source_list.ignore.category_name
        this.queryTagGroup = this.myObj.source_list.ignore.tag_group_name
    },
    methods: {
        /**
         * 查询大栏目
         */
        querySearchCategory(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetAtlasCategoryList(params)
                .then(data => {
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.categoryID
                        }
                    })
                    cb(list)
                })
        },
        /**
        * 查询标签组
        */
        querySearchTagGroup(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetAtlasTagGroup(params)
                .then(data => {
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.groupID
                        }
                    })
                    cb(list)
                })
        },
        handleSelectCategory(item) {
            this.queryStringCategory = item.value
            this.myObj.source_list.params.category_id = item.id
            //辅助回显信息
            this.myObj.source_list.ignore.category_name = item.value
        },
        handleSelectTagGroup(item) {
            this.queryStringTag = item.value
            this.myObj.source_list.params.tag_group_id = item.id
            //辅助回显信息
            this.myObj.source_list.ignore.tag_group_name = item.value
        },
    }
}
</script>

<style scoped lang="less">
.box {
    padding: 15px;
}
</style>